// src/components/layouts/admindashboard/header/sub/SearchInput.tsx

import React from "react";
import { Search } from "lucide-react";

interface SearchInputProps {
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({ className = "" }) => {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 transition-colors duration-200" />
      <input
        type="text"
        placeholder="Rechercher..."
        className="w-full pl-9 pr-4 py-2 rounded-xl bg-white/90 text-gray-800 border border-white/30 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent/50 focus:bg-white text-sm transition-all duration-200 shadow-sm"
      />
    </div>
  );
};

export default SearchInput;